/*
充电成功率--按月呈现
 */
import React, { Component } from "react";
import Echarts from "echarts";
import ScGridTable from "@/components/display/table/gridTableCore";
import Tool from "@/utils/Tool";
import { Spin } from "antd";

class StopReason extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    // 默认加载
    this.stubIntactChart(this.props.dataSource);
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig(this.props.dataSource);
  }

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {
      this.stubIntactChart(nextProps.dataSource);
      this.initTableConfig(nextProps.dataSource);
    }
  }

  /** */
  initTableConfig = (dataSource) => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessStopReasonTable",
        tableColumns: [
          {
            name: "停止原因",
            key: "endCodeName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "原因分类",
            key: "reasonTypeName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "占比",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart(dataSource) {
    // 数据设置
    // 对全量数据进行分类处理
    let { reasonGroupList, reasonList } = this.formatData(dataSource);

    // 计算各项数值所占百分比 获取总量
    let rgTotal = 0;
    let rTotal = 0;
    reasonList.map((v) => (rTotal += v.value));
    reasonGroupList.map((v) => (rgTotal += v.value));
    // 给各项添加百分比
    reasonGroupList = reasonGroupList.map((v) => {
      return {
        ...v,
        per: `${Tool.numberFormat((v.value / rgTotal) * 100)}%`,
      };
    });
    // 给各项添加百分比
    reasonList = reasonList.map((v) => {
      return {
        ...v,
        per: `${Tool.numberFormat((v.value / rTotal) * 100)}%`,
      };
    });
    // 给最后一项百分比补值
    reasonGroupList = Tool.setPercentWhileMathRound(reasonGroupList, reasonGroupList.length - 1);
    reasonList = Tool.setPercentWhileMathRound(reasonList, reasonList.length - 1);

    const colors = [
      "#EB7F66",
      "#F4DF58",
      "#75DDB2",
      "#7A79FF",
      "#C3FFF9",
      "#DD75C5",
      "#49C3F2",
      "#A4B3BD",
    ];

    const container = document.getElementById(
      this.props.chartId ? this.props.chartId[0] : "stop-reason-chart1",
    );
    const myChart1 = Echarts.init(
      document.getElementById(this.props.chartId ? this.props.chartId[0] : "stop-reason-chart1"),
    );
    const myChart2 = Echarts.init(
      document.getElementById(this.props.chartId ? this.props.chartId[1] : "stop-reason-chart2"),
    );

    const option = {
      title: {
        show: true,
        text: "原因分类占比",
        bottom: 30,
        left: container.offsetWidth * 0.235,
        // left: 20,
        textStyle: {
          fontSize: 14,
          color: "#454458",
        },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.5)",
        formatter: (params) => {
          const str = `<div style="padding:10px 24px 10px 10px;">${params.data.name}:${params.data.per}</div>`;
          return str;
        },
      },
      color: colors,
      legend: {
        textStyle: {
          padding: [5, 0],
        },
        formatter: (name) => {
          let value = "";
          reasonGroupList.map((item) => {
            if (item.name === name) {
              value = item.per;
            }
            return true;
          });
          if (name.length > 10) {
            name = `${name.replace(/\\n/g, "").substring(0, 10)}...`;
          }
          return `${name}   ${value}`;
        },
        left: "middle",
        top: "middle",
        itemWidth: 14,
        // align: 'right',
        orient: "vertical",
      },
      series: {
        type: "pie",
        name: "等级",
        radius: ["30%", "50%"],
        center: ["30%", "50%"],
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
        data:
          reasonGroupList.length === 0
            ? [{ name: "暂无数据", value: 0, per: "0.00%" }]
            : reasonGroupList,
      },
    };
    myChart1.clear();
    myChart2.clear();
    myChart1.setOption(option);
    myChart2.setOption({
      ...option,
      title: {
        ...option.title,
        text: "停止原因占比",
      },
      series: {
        ...option.series,
        data: reasonList.length === 0 ? [{ name: "暂无数据", value: 0, per: "0.00%" }] : reasonList,
      },
      legend: {
        ...option.legend,
        formatter: (name) => {
          let value = "";
          reasonList.map((item) => {
            if (item.name === name) {
              value = item.per;
            }
            return true;
          });

          if (name.length > 10) {
            name = `${name.replace(/\\n/g, "").substring(0, 10)}...`;
          }
          return `${name}   ${value}`;
        },
      },
    });
  }

  formatData = (dataSource) => {
    // 对数据源进行排行
    dataSource = dataSource.sort((a, b) => b.totalOrder - a.totalOrder);

    const reasonGroupList = [];
    const reasonList = [];
    // 对停止原因进行分类处理，获取某一类别的次数
    dataSource.map((v, index) => {
      // 如果分类未维护，则默认是操作相关
      if (v.reasonType === null) {
        v.reasonType = "0";
        v.reasonTypeName = "操作相关";
      }

      const info = reasonGroupList.find((n) => n.reasonType === v.reasonType);
      // 分组里是否已存在此分类
      if (info) {
        // 如果存在，订单相加
        info.value += v.totalOrder;
      } else {
        reasonGroupList.push({
          reasonType: v.reasonType,
          name: v.reasonTypeName,
          value: v.totalOrder,
        });
      }
      // 获取排名靠前的
      if (index < 7) {
        reasonList.push({
          name: v.endCodeName,
          value: v.totalOrder,
        });
      } else {
        // 如果存在其它 则对其它里面的订单数进行累加
        if (reasonList[7]) {
          reasonList[7].value += v.totalOrder;
        } else {
          reasonList.push({
            endCode: "other",
            name: "其它",
            value: v.totalOrder,
          });
        }
      }
      return true;
    });

    return {
      reasonGroupList,
      reasonList,
    };
  };

  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource);
        } else {
          this.initTableConfig(this.props.dataSource);
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className="section">
          <div className="title-box">
            <div className="title">{this.props.title || "停止原因"}</div>
            {!this.props.title && (
              <div className="btn-switch-box">
                <span
                  className={this.state.btnType === 1 && "selected-btn"}
                  onClick={() => this.btnChange(1)}>
                  图
                </span>
                <span
                  className={this.state.btnType === 2 && "selected-btn"}
                  onClick={() => this.btnChange(2)}>
                  表
                </span>
              </div>
            )}
          </div>
          {this.state.btnType === 1 ? (
            <div style={{ display: "flex" }}>
              <div
                style={{ width: "50%", height: 330, overflowY: "auto" }}
                id={this.props.chartId ? this.props.chartId[0] : "stop-reason-chart1"}
              />
              <div
                style={{ width: "50%", height: 330, overflowY: "auto" }}
                id={this.props.chartId ? this.props.chartId[1] : "stop-reason-chart2"}
              />
            </div>
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default StopReason;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/stopReason.js